import { useState, useEffect } from 'react';
import { apiClient } from '../../../../services/apiClient';

export const useObjectTypeActivities = (activeFile, objectType) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeFile || !objectType) {
      setActivities([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    apiClient
      .get('/object-type-activities', { params: { file_type: activeFile } })
      .then((res) => {
        if (cancelled) return;
        setActivities(res.data?.objectTypeActivities?.[objectType] || []);
      })
      .catch(() => {
        if (!cancelled) setActivities([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [activeFile, objectType]);

  return { activities, loading };
};
